// src/app/redux/reducers/ordreMissionReducer.js
import {
    FETCH_ORDRE_MISSION_REQUEST,
    FETCH_ORDRE_MISSION_SUCCESS,
    FETCH_ORDRE_MISSION_FAIL,
    FETCH_ORDRE_MISSION_BY_ID_REQUEST,
    FETCH_ORDRE_MISSION_BY_ID_SUCCESS,
    FETCH_ORDRE_MISSION_BY_ID_FAIL,
    CREATE_ORDRE_MISSION_REQUEST,
    CREATE_ORDRE_MISSION_SUCCESS,
    CREATE_ORDRE_MISSION_FAIL,
    UPDATE_ORDRE_MISSION_REQUEST,
    UPDATE_ORDRE_MISSION_SUCCESS,
    UPDATE_ORDRE_MISSION_FAIL,
    DELETE_ORDRE_MISSION_REQUEST,
    DELETE_ORDRE_MISSION_SUCCESS,
    DELETE_ORDRE_MISSION_FAIL,
    FETCH_ORDRE_MISSION_ACTIFS_REQUEST,
    FETCH_ORDRE_MISSION_ACTIFS_SUCCESS,
    FETCH_ORDRE_MISSION_ACTIFS_FAIL,
    FETCH_ORDRE_MISSION_EN_COURS_REQUEST,
    FETCH_ORDRE_MISSION_EN_COURS_SUCCESS,
    FETCH_ORDRE_MISSION_EN_COURS_FAIL,
    FETCH_ORDRE_MISSION_BY_PERIOD_REQUEST,
    FETCH_ORDRE_MISSION_BY_PERIOD_SUCCESS,
    FETCH_ORDRE_MISSION_BY_PERIOD_FAIL,
    SET_ORDRE_MISSION_LOADING,
    CLEAR_ORDRE_MISSION_ERROR,
} from "../actions/ordreMissionActions";

const initialState = {
    loading: false,
    error: null,
    ordresMission: [],
    currentOrdreMission: null,
    ordresMissionActifs: [],
    ordresMissionEnCours: [],
    ordresMissionByPeriod: [],
};

export default function ordreMissionReducer(state = initialState, action) {
    switch (action.type) {
        // ========== LOADING & ERROR ==========
        case SET_ORDRE_MISSION_LOADING:
            return { ...state, loading: action.payload };

        case CLEAR_ORDRE_MISSION_ERROR:
            return { ...state, error: null };

        // ========== FETCH ALL ==========
        case FETCH_ORDRE_MISSION_REQUEST:
            return { ...state, loading: true, error: null };

        case FETCH_ORDRE_MISSION_SUCCESS:
            console.log("🟢 REDUCER: FETCH_ORDRE_MISSION_SUCCESS", action.payload);
            return {
                ...state,
                loading: false,
                error: null,
                ordresMission: action.payload || [],
            };

        case FETCH_ORDRE_MISSION_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
                ordresMission: []
            };

        // ========== FETCH BY ID ==========
        case FETCH_ORDRE_MISSION_BY_ID_REQUEST:
            return { ...state, loading: true, error: null };

        case FETCH_ORDRE_MISSION_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                currentOrdreMission: action.payload,
            };

        case FETCH_ORDRE_MISSION_BY_ID_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        // ========== CREATE ==========
        case CREATE_ORDRE_MISSION_REQUEST:
            return { ...state, loading: true, error: null };

        case CREATE_ORDRE_MISSION_SUCCESS:
            console.log("🟢 REDUCER: CREATE_ORDRE_MISSION_SUCCESS", action.payload);
            return {
                ...state,
                loading: false,
                error: null,
                ordresMission: [action.payload, ...state.ordresMission],
            };

        case CREATE_ORDRE_MISSION_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        // ========== UPDATE ==========
        case UPDATE_ORDRE_MISSION_REQUEST:
            return { ...state, loading: true, error: null };

        case UPDATE_ORDRE_MISSION_SUCCESS: {
            const updated = action.payload;
            console.log("🟢 REDUCER: UPDATE_ORDRE_MISSION_SUCCESS", updated);
            return {
                ...state,
                loading: false,
                error: null,
                ordresMission: (state.ordresMission || []).map((o) =>
                    o.id === updated.id ? updated : o
                ),
                currentOrdreMission: state.currentOrdreMission?.id === updated.id
                    ? updated
                    : state.currentOrdreMission,
            };
        }

        case UPDATE_ORDRE_MISSION_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        // ========== DELETE ==========
        case DELETE_ORDRE_MISSION_REQUEST:
            return { ...state, loading: true, error: null };

        case DELETE_ORDRE_MISSION_SUCCESS:
            console.log("🟢 REDUCER: DELETE_ORDRE_MISSION_SUCCESS", action.payload);
            return {
                ...state,
                loading: false,
                error: null,
                ordresMission: state.ordresMission.filter((o) => o.id !== action.payload),
            };

        case DELETE_ORDRE_MISSION_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        // ========== FETCH ACTIFS ==========
        case FETCH_ORDRE_MISSION_ACTIFS_REQUEST:
            return { ...state, loading: true, error: null };

        case FETCH_ORDRE_MISSION_ACTIFS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                ordresMissionActifs: action.payload || [],
            };

        case FETCH_ORDRE_MISSION_ACTIFS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        // ========== FETCH EN COURS ==========
        case FETCH_ORDRE_MISSION_EN_COURS_REQUEST:
            return { ...state, loading: true, error: null };

        case FETCH_ORDRE_MISSION_EN_COURS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                ordresMissionEnCours: action.payload || [],
            };

        case FETCH_ORDRE_MISSION_EN_COURS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        // ========== FETCH BY PERIOD ==========
        case FETCH_ORDRE_MISSION_BY_PERIOD_REQUEST:
            return { ...state, loading: true, error: null };

        case FETCH_ORDRE_MISSION_BY_PERIOD_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                ordresMissionByPeriod: action.payload || [],
            };

        case FETCH_ORDRE_MISSION_BY_PERIOD_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        default:
            return state;
    }
}